import axios from 'axios';
import { config } from '../config/environment';

const API_BASE_URL = config.API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log(`API İsteği: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Hatası:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const apiService = {
  // Uygulamaları listele
  getProcesses: async () => {
    const response = await api.get('/processes');
    return response.data;
  },

  // Belirli bir uygulama detaylarını al
  getProcess: async (processId: string) => {
    const response = await api.get(`/processes/${processId}`);
    return response.data;
  },

  // Uygulama başlat
  startProcess: async (options: {
    script: string;
    name?: string;
    instances?: number;
    watch?: boolean;
    autorestart?: boolean;
  }) => {
    const response = await api.post('/start', options);
    return response.data;
  },

  // Uygulama durdur
  stopProcess: async (processId: string) => {
    const response = await api.post(`/stop/${processId}`);
    return response.data;
  },

  // Uygulama yeniden başlat
  restartProcess: async (processId: string) => {
    const response = await api.post(`/restart/${processId}`);
    return response.data;
  },

  // Uygulama sil
  deleteProcess: async (processId: string) => {
    const response = await api.delete(`/processes/${processId}`);
    return response.data;
  },

  // Logları al
  getLogs: async (processId: string, lines: number = 100) => {
    const response = await api.get(`/logs/${processId}?lines=${lines}`);
    return response.data;
  },

  // Sistem bilgilerini al
  getSystemInfo: async () => {
    const response = await api.get('/system');
    return response.data;
  },

  // Monitoring verilerini al
  getMonitoringData: async () => {
    const response = await api.get('/monitoring');
    return response.data;
  },

  // Tüm uygulamaları durdur
  stopAllProcesses: async () => {
    const response = await api.post('/stop-all');
    return response.data;
  },

  // Tüm uygulamaları yeniden başlat
  restartAllProcesses: async () => {
    const response = await api.post('/restart-all');
    return response.data;
  },

  // Sunucu yönetimi
  getServers: async () => {
    const response = await api.get('/servers');
    return response.data;
  },

  addServer: async (serverData: { name: string; description?: string }) => {
    const response = await api.post('/servers', serverData);
    return response.data;
  },

  deleteServer: async (serverId: string) => {
    const response = await api.delete(`/servers/${serverId}`);
    return response.data;
  },

  getServer: async (serverId: string) => {
    const response = await api.get(`/servers/${serverId}`);
    return response.data;
  },

  getServerConnection: async (serverId: string) => {
    const response = await api.get(`/servers/${serverId}/connection`);
    return response.data;
  },

  getServerStats: async () => {
    const response = await api.get('/servers/stats/overview');
    return response.data;
  },
};

export default apiService;
